import { MapPin, Palette, Cpu, Download, ArrowRight } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: MapPin,
    title: 'Konum Gir',
    description: 'Mülkünüzün adresini, koordinatlarını veya ilan linkini sisteme girin. TKGM parsel numarası da kullanabilirsiniz.',
  },
  {
    number: '02',
    icon: Palette,
    title: 'Tasarımı Seç',
    description: 'Markanıza ve mülk tipine uygun video stilini belirleyin. Seslendirme dili ve tonunu seçin.',
  },
  {
    number: '03',
    icon: Cpu,
    title: 'Yapay Zeka',
    description: 'Uydu görüntüleri ve fotoğraflar yapay zeka ile sinematik hale getirilsin. Otomatik analiz yapılsın.',
  },
  {
    number: '04',
    icon: Download,
    title: 'Videoyu İndir',
    description: 'Profesyonel videonuzu, infografiğinizi veya raporunuzu anında indirin ve paylaşın.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="section-padding">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                          bg-primary/10 text-primary text-sm font-semibold mb-4">
            Nasıl Çalışır?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
            4 Kolay Adımda <span className="gradient-text">Videonuz Hazır</span>
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Karmaşık süreçleri geride bırakın, yapay zeka sizin için çalışsın.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative group"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 
                                bg-slate-200 dark:bg-slate-700 -translate-y-1/2 z-0">
                  <ArrowRight className="absolute right-0 top-1/2 -translate-y-1/2 w-4 h-4 
                                         text-slate-300 dark:text-slate-600" />
                </div>
              )}

              <div className="card p-8 h-full hover:border-primary/30 transition-all duration-300 
                              relative overflow-hidden">
                {/* Step number background */}
                <div className="absolute -right-4 -top-4 text-8xl font-black text-slate-100 
                                dark:text-slate-800 opacity-50 group-hover:text-primary/10 
                                transition-colors select-none">
                  {step.number}
                </div>

                <div className="relative z-10">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-primary/10 text-primary 
                                  flex items-center justify-center mb-6 
                                  group-hover:bg-primary group-hover:text-white 
                                  transition-colors duration-300">
                    <step.icon className="w-7 h-7" />
                  </div>

                  <h3 className="text-xl font-bold mb-3 text-slate-900 dark:text-white">
                    {step.title}
                  </h3>
                  <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
